module.exports = __webpack_public_path__ + "img/symbol_5.f545b2e4.png";